<template>
    <div class="attribute-wrapper section-space--pt_120" id="about">
        <div class="container_fl">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <div class="single-attribute col-06__left">
                        <div class="section-title-wrapper section-space--mb_60">
                            <h3 class="font-weight--light text-black section-space--mb_30 wow move-up text-primary">Tecnologie brevettate</h3>
                            <div class="sub-text wow move-up">
                                Le innovazioni del sistema AutoMicook riguardano: i contenitori, i vassoi, i carrelli di riattivazione  e un sistema di cottura a microonde, che permettono di cucinare le pietanze in condizioni di  microaerofila (atmosfera a basso contenuto di ossigeno), bassa pressione e basse temperature. Come dimostrato da ricerche dell’Università di Verona, queste tecnologie consentono di ridurre  al minimo le perdite delle componenti nutrizionali e funzionali (sostanze benefiche che stimolano  il buon funzionamento dell’organismo), ossia quelle più facilmente deteriorabili. 
                            </div>
                            <div class="sub-text wow move-up mt-5">
                                I vantaggi di AutoMicook si raggiungono grazie ad un brevetto che riguarda l’intero processo  produttivo e distributivo delle pietanze per la ristorazione collettiva. Le innovazioni rivendicate  permettono l’automazione completa di tutto il processo, ossia preparazione, impiattamento,  confezionamento, cottura, conservazione, distribuzione, riattivazione, fino allo sbarazzo vassoi,  lavaggio e stoccaggio stoviglie. 
                            </div>
                        </div>
                        <!-- <ul class="attribute_list_one  section-space--mb_50 wow move-up">
                            <li class="item">
                                <div class="name">
                                    <h6>Size</h6>
                                </div>
                                <div class="value">70mm x70mm x 25mm</div>
                            </li>
                            <li class="item">
                                <div class="name">
                                    <h6>Weight</h6>
                                </div>
                                <div class="value">196g</div>
                            </li>
                            <li class="item">
                                <div class="name">
                                    <h6>Materials</h6>
                                </div>
                                <div class="value">Aluminium / textile / Rubber /<br>Polymer / Foam / Silicone / Nylon</div>
                            </li>
                            <li class="item">
                                <div class="name">
                                    <h6>Frequeency</h6>
                                </div>
                                <div class="value">20 - 20,000 Hz</div>
                            </li>
                        </ul>
                        <h6 class="text-black wow move-up">What’s next in AeroLand? <a href="#" class="hover-style-link hover-style-link--green">Learn more</a></h6> -->
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="attribute-image text-right wow move-up">
                        <img class="img-fluid" src="@/assets/img/micook/micook_3.png" alt="about">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default{
        name: 'AboutProductShowcase',
    };
</script>